import React, { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  title?: string;
  titleAction?: ReactNode;
  hover?: boolean;
  style?: React.CSSProperties;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  title,
  titleAction,
  hover = false,
  style,
}) => {
  const cardClass = hover ? 'card glass-card-hover' : 'card';

  return (
    <div className={`${cardClass} ${className}`.trim()} style={style}>
      {title && (
        <div className="card-header">
          <h4 className="card-title">{title}</h4>
          {titleAction && <div>{titleAction}</div>}
        </div>
      )}
      <div className="card-body">{children}</div>
    </div>
  );
};
